import { base64ToUint8Array } from '../../helpers/base64ToUint8Array'

export const adjuntoBuilder = async (dataAdjunto, adjunto, filename, options = {}) => {
  const { preview = false, isBase64 = true } = options

  const contentType =
    adjunto?.contentType?.trim().replace('\\', '/').toLowerCase() ||
    adjunto?.mimeType?.trim().replace('\\', '/').toLowerCase() ||
    adjunto?.mimetype?.trim().replace('\\', '/').toLowerCase() ||
    (adjunto?.extension?.trim().toLowerCase() === 'pdf'
      ? 'application/pdf'
      : 'application/octet-stream')

  // El back de EBM devuelve el archivo en base64, es necesario convertirlo a Uint8Array para crear correctamente el Blob
  const bytes = isBase64 ? base64ToUint8Array(dataAdjunto) : dataAdjunto
  const blob = new Blob([bytes], {
    type: contentType || dataAdjunto?.type || 'application/octet-stream'
  })
  const fileURL = URL.createObjectURL(blob)

  // Vista previa del archivo, util para la mensajeria ya que no tiene que borrar la URL generada
  if (preview) {
    return {
      url: fileURL,
      nombre: adjunto?.archivo || filename || 'archivo',
      contentType,
      orden: adjunto.orden,
      idAdjunto: adjunto.idAdjunto
    }
  }

  // Si entra aca es para descargar(abrir en una nueva pestaña en caso de PDF) el archivo, por lo que se debe revocar la URL generada
  try {
    if (adjunto) {
      if (adjunto.extension?.trim().toUpperCase() === 'PDF' && contentType === 'application/pdf') {
        window.open(fileURL, '_blank')
      } else {
        const link = document.createElement('a')
        link.href = fileURL
        link.setAttribute('download', adjunto.archivo || filename || 'archivo')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    } else {
      const link = document.createElement('a')
      link.href = fileURL
      link.setAttribute('download', `${filename || 'archivo'}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  } finally {
    URL.revokeObjectURL(fileURL)
  }
}
